import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toFixed',
})
export class ToFixedPipe implements PipeTransform {
  transform( n?: number, x = 0): any {
    return n? n.toFixed(x? x: 0) : 0;  
  }
}
